import { Text, Grid, theme, breakpoints, Box } from '@gassan-ui'
import styled from 'styled-components'
import { rem } from 'polished'

export const Description = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: ${theme.colors.shades[500]};
`

export const Parent = styled(Grid)`
  grid-template-columns: 3.75rem 1fr;
  grid-column-gap: 1rem;

  @media screen and (min-width: ${breakpoints.small}) {
    grid-template-columns: 11rem 1fr 8rem;
  }

  @media screen and (min-width: ${breakpoints.large}) {
    grid-column-gap: 2.5rem;
  }
`

export const NotAvailable = styled(Box)`
  width: 100%;
  background: ${theme.colors.pampas};
  position: relative;

  &:before {
    content: '';
    background: ${theme.colors.pampas};
    position: absolute;
    left: ${rem(24)};
    height: ${rem(11)};
    width: ${rem(11)};
    top: ${rem(-6)};
    transform: rotate(45deg);

    @media screen and (min-width: ${breakpoints.small}) {
      left: ${rem(81)};
      height: ${rem(14)};
      width: ${rem(14)};
      top: ${rem(-8)};
    }
  }
`
